import { Text } from "@mantine/core";
import { EntityClientAction, openEntityForm } from "@mcurros2/microm";
import { Tiendas } from "../../Tiendas/Tiendas";

export const ACTVerTienda: EntityClientAction = {
    name: 'ACTVerTienda',
    label: 'Ver Tienda',
    title: <Text fw={700}>Ver Tienda</Text>,
    refreshOnClose: true,
    dontRequireSelection: false,
    showActionInViewMode: true,
    minSelectedRecords: 1,
    maxSelectedRecords: 1,
    views: ['plti_brwGestionTiendasPersonal', 'plti_brwGestionTiendasPersonalAgregar'],
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {

        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }

        const tiendas = new Tiendas(entity.API.client);
        tiendas.def.columns.c_tienda_id.value = selectedKeys?.[0].c_tienda_id as string;

        await openEntityForm({
            modals: modal,
            formProps: {
                entity: tiendas,
                initialFormMode: 'view',
                getDataOnInit: true,
            },
            modalFormSize: 'xl',
            handleModalSaved: async () => { await modal.close(); if (onClose) await onClose(false); },
            handleModalCancel: async () => { await modal.close(); if (onClose) await onClose(false); }
        });

        return false;
    }
}